import { createContext } from "react"
import type { ContentMapContextValue } from "@/utils/contentMapTypes"

export const ContentMapContext = createContext<ContentMapContextValue | null>(
  null
)
